import React from 'react';
import NewTabLink from '@sls-react/components/Links/NewTabLink';
import TradeInLanderCard from '@sls-react/components/TradeIn/TradeInLanderCard';
import { Button } from '@sls-react/components/Form/Button';
import { EVENT_DETAILS } from '../../pages/trade-in-events';
import MOBILE_HERO from '@sls-react/static/trade-in/mobile-hero.jpg';

interface Props {}

const TradeInMobileLander: React.FC<Props> = () => {
  return (
    <>
      <div
        className="flex flex-col justify-center px-4 text-white bg-cover h-72 space-y-2"
        style={{
          backgroundImage: `url(${MOBILE_HERO})`,
        }}
      >
        <h1 className="text-6xl font-bold leading-tight uppercase">
          Trade-in
          <br />
          Events
        </h1>
        <h2 className="text-2xl uppercase">Powered by SidelineSwap</h2>
        <NewTabLink
          href="https://forms.gle/9djujT3fxhfmwaqr7"
          className="text-lg underline"
        >
          Host your own event
        </NewTabLink>
      </div>

      <div className="container mt-6 space-y-10">
        <section>
          <h2 className="mb-3 text-3xl font-bold uppercase text-true-black">
            Upcoming Events
          </h2>
          <NewTabLink
            className="text-xl font-semibold underline uppercase text-slate-green-500"
            href="https://sidelineswap.com/blog/p/311c275c-4404-4d6f-938b-bfffc8426b64/"
          >
            View Trade-in Guidelines
          </NewTabLink>
        </section>

        <hr />

        {EVENT_DETAILS.map((event, i) => (
          <>
            <article key={i} className="space-y-6">
              <div>
                <div className="mb-2 text-xl font-semibold text-true-black">
                  Where
                </div>
                <div className="text-lg font-semibold leading-tight text-slate-green-500">
                  {event.where.map(where => (
                    <div key={where}>{where}</div>
                  ))}
                </div>
              </div>

              <div>
                <div className="mb-2 text-xl font-semibold text-true-black">
                  When
                </div>
                <div className="text-lg font-bold leading-tight text-green-500 uppercase">
                  {event.when}
                </div>
              </div>
            </article>
            <hr />
          </>
        ))}
      </div>

      <div className="container mt-6 space-y-6">
        <TradeInLanderCard
          header="HOST"
          content="Want to plan a trade-in event to help your community cash in on their gear?"
          cta={
            <NewTabLink href="https://forms.gle/9djujT3fxhfmwaqr7">
              <Button>JOIN THE WAITING LIST</Button>
            </NewTabLink>
          }
        />

        <TradeInLanderCard
          header="WANT TO SELL MORE GEAR?"
          content="Trade-in events are easy to run and a great way for SidelineSwap sellers to grow their business."
          cta={
            <a href="mailto:partnerships@sidelineswap.com">
              <Button>CONTACT US</Button>
            </a>
          }
        />
      </div>
    </>
  );
};

export default TradeInMobileLander;
